var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderIconClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1465_37214",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1465_37214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 13.0496L8.32461 16.7246C8.18711 16.8621 8.01211 16.9309 7.79961 16.9309C7.58711 16.9309 7.41211 16.8621 7.27461 16.7246C7.13711 16.5871 7.06836 16.4121 7.06836 16.1996C7.06836 15.9871 7.13711 15.8121 7.27461 15.6746L10.9496 11.9996L7.27461 8.32461C7.13711 8.18711 7.06836 8.01211 7.06836 7.79961C7.06836 7.58711 7.13711 7.41211 7.27461 7.27461C7.41211 7.13711 7.58711 7.06836 7.79961 7.06836C8.01211 7.06836 8.18711 7.13711 8.32461 7.27461L11.9996 10.9496L15.6746 7.27461C15.8121 7.13711 15.9871 7.06836 16.1996 7.06836C16.4121 7.06836 16.5871 7.13711 16.7246 7.27461C16.8621 7.41211 16.9309 7.58711 16.9309 7.79961C16.9309 8.01211 16.8621 8.18711 16.7246 8.32461L13.0496 11.9996L16.7246 15.6746C16.8621 15.8121 16.9309 15.9871 16.9309 16.1996C16.9309 16.4121 16.8621 16.5871 16.7246 16.7246C16.5871 16.8621 16.4121 16.9309 16.1996 16.9309C15.9871 16.9309 15.8121 16.8621 15.6746 16.7246L11.9996 13.0496Z",
    fill: "#9E9E9E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderIconClose);
export default __webpack_public_path__ + "static/media/header-icon-close.0a6d5033aa54a33a2faa68838f8b9159.svg";
export { ForwardRef as ReactComponent };